var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{'sidebar--lg--show' : _vm.getKeys.openSidebar},attrs:{"id":"app"}},[(_vm.pageLoading)?_c('div',{staticClass:"loading--screen"},[_c('span')]):_vm._e(),_c('Sidebar'),_c('Screens')],1)}
var staticRenderFns = []

export { render, staticRenderFns }